import Http from "../helpers/Http";

class PackageDataService {

  getAll(data) {
    return Http.post("/packages/list", data);
   
  }

  get(id) {
    return Http.get(`/packages/${id}`);
  }

  create(data) {
    return Http.post("/packages",data);
  }

  update(data) {
    return Http.update("/packages",data);
  }

  calculatorRate(data) {
    return Http.post("/packages/cost",data);
  }

  getPackStats(){
    return Http.get("/packages/stats/total");
  }

  updateStatus(data) {
    return Http.update("/packages/changestatus",data);
  }
  
  getStatusAvailables() {
    return Http.get("/status/packages");
  }

  updatePackageCost(data) {
    return Http.post("/packages/recalculate",data);
  }

  sendToBilled(data) {
    return Http.update("/package/finalize",data);
  }

  downloadPackages(data){
    return Http.downloadFiles("/reports/packages",data);
  }
  
  sendReportByEmail(data){
    return Http.post("/reports/packages/mail",data);
  }

  createNote(data) {
    return Http.post("/packages/notes",data);
  }
  updateNote (data) {
    return Http.post("/packages/notes/edit",data);
  }

  delete(data) {
    return Http.update("/package/delete",data);
  }
  
  reportSales(data){
    return Http.post("/reports/sales",data);
  }
  
  downloadReportSales(data){
    return Http.downloadFiles("/reports/salesFile",data);
  }

  statusPreAlert(data){
    return Http.post("/packages/preAlerted",data);
  }

  statusFollowUp(data){
    return Http.post("/packages/followUp",data);
  }
  
  validTracking(data){
    return Http.post("/packages/validateTracking",data);
  }

  saveUserFeedback(data){
    return Http.post("/packages/surveys ",data);
  }

  getSurveys(data){
    return Http.post("/packages/surveys/list ",data);
  }

  downloadSurveys(data){
    return Http.downloadFiles("/packages/surveys/export",data);
  }

  matrixCustomers(){
    return Http.downloadFiles("/reports/matrixCustomers");
  }

  matrixMonth(){
    return Http.downloadFiles("/reports/matrixMonth");
  }

  getPackagesUser() {
    return Http.post("/packages/stats/total/customer");
  }

}

export default new PackageDataService();